import React, { useEffect, useRef, useState } from 'react';
import { X, Clipboard } from 'lucide-react';
import QRCodeStyling from 'qr-code-styling';
import toast from 'react-hot-toast';

// The site's QR look (MFL logo in the centre, error correction Q so the logo
// doesn't break scanning). Shared by fighter share QRs and judge-link QRs.
export const mflQrOptions = (data, size = 240) => ({
    width: String(size),
    height: String(size),
    type: 'png',
    data,
    image: '/assets/img/logo-mfl.png',
    margin: 4,
    qrOptions: {
        typeNumber: 0,
        mode: 'Byte',
        errorCorrectionLevel: 'Q'
    },
    imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 4,
        crossOrigin: 'anonymous',
    },
    dotsOptions: {
        color: '#222222',
        type: 'classy-rounded'
    },
    backgroundOptions: {
        color: 'white',
    },
    cornersSquareOptions: {
        color: '#222222',
    },
    cornersDotOptions: {
        color: '#222222',
    }
});

const FighterQr = ({ children, url }) => {
    const shareModal = useRef(null);
    const qrCanvas = useRef(null);
    const [qrCode, setQrCode] = useState(null);

    const handleShare = () => {
        if (shareModal?.current) {
            shareModal.current.showModal();
        }
    }

    const handleDownloadQr = () => {
        if (!qrCode) return;
        qrCode.download({
            extension: "png"
        });
    };

    const handleCopyUrl = () => {
        if (navigator?.clipboard) {
            navigator.clipboard.writeText(url);
            toast("📋 Copied URL to Clipboard");
        }
    }

    useEffect(() => {
        if (url) {
            setQrCode(new QRCodeStyling(mflQrOptions(url)))
        }
    }, [url])

    useEffect(() => {
        if (qrCanvas.current) {
            qrCanvas.current.innerHTML = null;
            if (qrCode) {
                qrCode.append(qrCanvas.current);
            }
        }
    }, [qrCode])

    return (
        <>
            <div onClick={handleShare}>
                {children}
            </div>

            <dialog ref={shareModal} className="modal">
                <div className="modal-box border">
                    <div className='flex flex-row justify-between items-center'>
                        <h3 className="font-bold text-lg">Share to others</h3>
                        <form method="dialog">
                            <button className='btn btn-ghost btn-square btn-sm'>
                                <X />
                            </button>
                        </form>
                    </div>
                    <br />
                    <div className='flex-center w-full gap-2'>
                        <div className='object-center object-contain aspect-square' ref={qrCanvas} />
                        <br />
                        <form className='w-full' method="dialog">
                            <button className="btn btn-outline w-full" onClick={handleDownloadQr}>
                                Download
                            </button>
                        </form>
                        <div className='flex flex-row justify-between items-center w-full border'>
                            <p className='truncate px-4'>
                                {url}
                            </p>
                            <form method="dialog">
                                <button className="btn btn-primary btn-small btn-square" onClick={handleCopyUrl}>
                                    <Clipboard />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button>close</button>
                </form>
            </dialog>
        </>
    );
}

export default FighterQr;
